import { CurrentCartState } from '@common/store';
import { deepCopy } from '@common/helper/deep-copy';
import { TestData_PASSENGER as PASS } from '../passenger-test-data';
import { TestData_BOUND as BOUND } from '../bound-test-data';

export function getLoungeTestData(data: CurrentCartState): any {
  if (!data.data?.plan?.services) {
    return data;
  }
  data.data.cartId = 'CART_ID001';
  data.data.plan.services.lounge = {};
  data.data.plan.services.lounge['ID001'] = { isAvailable: true };
  data.data.plan.services.lounge['ID002'] = { isAvailable: false };
  data.data.plan.services.lounge['ID001'].isAvailable = true;
  data.data.plan.services.lounge['ID001']['PASSENGER00101'] = PASSENGER1;
  data.data.plan.services.lounge['ID001']['PASSENGER00102'] = PASSENGER2;
  data.data.plan.services.lounge['ID001']['PASSENGER00103'] = PASSENGER3;
  data.data.plan.services.lounge['ID002']['PASSENGER00201'] = PASSENGER3;
  data.data.plan.services.lounge['ID003'] = { isAvailable: true };
  data.data.plan.services.lounge['ID003']['TRAVELER_R01_M51_1'] = PASSENGER_R01_M51_1;
  data.data.plan.services.lounge['ID003']['TRAVELER_R01_M51_2'] = PASSENGER_R01_M51_2;
  data.data.plan.services.lounge['ID003']['TRAVELER_R01_M51_3'] = PASSENGER_R01_M51_3;
  data.data.plan.services.lounge['ID003']['TRAVELER_R01_M51_4'] = PASSENGER_R01_M51_4;
  data.data.plan.services.lounge['ID003']['TRAVELER_R01_M51_5'] = PASSENGER_R01_M51_5;
  data.data.plan.services.lounge['ID003']['TRAVELER_R01_M51_6'] = PASSENGER_R01_M51_6;
  data.data.plan.services.lounge['ID003']['TRAVELER_R01_M51_7'] = PASSENGER_R01_M51_7;
  data.data.plan.services.lounge['ID005'] = { isAvailable: true };
  data.data.plan.services.lounge['ID005']['TRAVELER_R01_M51_5'] = PASSENGER_R01_M51_5;
  if (data.data?.plan?.airOffer?.bounds) {
    data.data.plan.airOffer.bounds = [BOUND.bound1, BOUND.bound3];
  }
  if (data.data?.plan?.travelers) {
    data.data.plan.travelers = [
      PASS.TRAVELER1,
      PASS.TRAVELER2,
      PASS.TRAVELER3,
      PASS.TRAVELER4,
      PASS.TRAVELER5,
      PASS.TRAVELER_R01_M51_1,
      PASS.TRAVELER_R01_M51_2,
      PASS.TRAVELER_R01_M51_3,
      PASS.TRAVELER_R01_M51_4,
      PASS.TRAVELER_R01_M51_5,
      PASS.TRAVELER_R01_M51_6,
      PASS.TRAVELER_R01_M51_7,
    ];
  }
  return data;
}

const LOUNGE_VATALOGUE_LOUG = {
  code: 'LOUG',
  quota: '1',
  prices: {
    total: 12345,
    currencyCode: 'JPY',
  },
};
const LOUNGE_VATALOGUE_MYLG = {
  code: 'MYLG',
  quota: '15',
  prices: {
    total: 999999,
    currencyCode: 'JPY',
  },
};

export const DEFAULT_PASSENGER = {
  code: '',
  id: 'SERVICEID001',
  statusCode: 'HK',
  serviceStatus: '',
  isMyBaggageRequested: false,
  isWaived: false,
  isAvailable: false,
  prices: {
    total: 10000.96,
    currencyCode: 'USD',
  },
  catalogue: [LOUNGE_VATALOGUE_LOUG],
};

export const PASSENGER1 = {
  ...deepCopy(DEFAULT_PASSENGER),
  code: 'LOUG',
  id: 'SERVICEID001',
  prices: {
    total: 10000,
    currencyCode: 'JPY',
  },
};

export const PASSENGER2 = {
  ...deepCopy(DEFAULT_PASSENGER),
  id: 'SERVICEID002',
  isWaived: true,
  prices: {
    total: 9000,
    currencyCode: 'JPY',
  },
  catalogue: [{ ...LOUNGE_VATALOGUE_LOUG, quota: '0' }],
};

export const PASSENGER3 = {
  ...deepCopy(DEFAULT_PASSENGER),
  id: 'SERVICEID001',
  prices: {
    total: 12000,
    currencyCode: 'JPY',
  },
  catalogue: [LOUNGE_VATALOGUE_LOUG, LOUNGE_VATALOGUE_MYLG],
};

export const PASSENGER4 = {
  ...deepCopy(DEFAULT_PASSENGER),
  id: 'SERVICEID001',
  prices: {
    total: 12000,
    currencyCode: 'JPY',
  },
  catalogue: [
    {
      ...LOUNGE_VATALOGUE_LOUG,
      quota: '2',
    },
  ],
};

export const PASSENGER5 = {
  ...deepCopy(DEFAULT_PASSENGER),
  id: 'SERVICEID001',
  prices: {
    total: 12000,
    currencyCode: 'JPY',
  },
  catalogue: [LOUNGE_VATALOGUE_LOUG],
};

export const PASSENGER_R01_M51_1 = {
  ...deepCopy(DEFAULT_PASSENGER),
  isWaived: true,
};
export const PASSENGER_R01_M51_2 = {
  ...deepCopy(DEFAULT_PASSENGER),
  catalogue: [
    {
      ...LOUNGE_VATALOGUE_MYLG,
      quota: '0',
    },
  ],
};
export const PASSENGER_R01_M51_3 = {
  ...deepCopy(DEFAULT_PASSENGER),
};
export const PASSENGER_R01_M51_4 = {
  ...deepCopy(DEFAULT_PASSENGER),
  catalogue: [{ ...LOUNGE_VATALOGUE_LOUG, quota: '1' }, LOUNGE_VATALOGUE_MYLG],
  code: 'MYLG',
};
export const PASSENGER_R01_M51_5 = {
  ...deepCopy(DEFAULT_PASSENGER),
};
export const PASSENGER_R01_M51_6 = {
  ...deepCopy(DEFAULT_PASSENGER),
  catalogue: [],
};
export const PASSENGER_R01_M51_7 = {
  ...deepCopy(DEFAULT_PASSENGER),
  serviceStatus: 'requested',
  code: 'LOUG',
};
